import { render } from "./LiveResults.vue?vue&type=template&id=f31fe922"
import script from "./LiveResults.vue?vue&type=script&lang=js"
export * from "./LiveResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__